<template>
  <div>
    <header id="header" class="header-two">
      <div v-if="isATestingEnv" class="text-center py-2 text-sm" style="background: #dc2626; color: white; ">
        This is a test system for testing purposes only
      </div>
      <div class="container-fluid page-container">
        <div class="navigation-container">
          <div class="navbar-header">
            <div class="">
              <a
                  :href="webUrl">
                <img
                  src="@/assets/images/header_logo_white.png"
                  alt="The Rent Roll Broker"
                  class="header-logo"
                />
              </a>
            </div>
            <!-- logo end -->
          </div>
          <!-- Navbar header end -->

          <nav class="site-navigation navigation pull-right">
            <div class="site-nav-inner">
              <div class="collapse navbar-collapse navbar-responsive-collapse">
                <ul class="nav navbar-nav">
                  <li>
                    <a
                        :href="webUrl + '/rent-roll-listings'"
                        :class="[{ '!text-secondary font-semibold': $route.path === '/rent-roll-listings' }]"
                      >
                        Listings
                    </a>
                  </li>
                  <li>
                    <a
                        href="#"
                        class="dropdown-toggle"
                    >
                    <span class="mr-5">Register</span>
                      <i class="fa fa-angle-down"></i>
                    </a>
                    <ul
                      class="dropdown-menu"
                      role="menu"
                    >
                      <li>
                        <a
                          :href="webUrl + '/buy-a-business'"
                        >
                          As a Buyer
                        </a>
                      </li>
                      <li>
                        <a
                          :href="webUrl + '/sell-a-business'"
                        >
                          As a Seller
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a
                        :href="webUrl + '/resources/articles'"
                        class="dropdown-toggle"
                    >
                      <span class="mr-5">Resources</span>
                        <i class="fa fa-angle-down"></i>
                      </a>
                    <ul
                      class="dropdown-menu"
                      role="menu"
                    >
                      <li>
                        <a
                          :href="webUrl + '/resources/articles'"
                        >
                          Articles
                        </a>
                      </li>
                      <li>
                        <a
                          :href="webUrl + '/resources/affiliates'"
                        >
                          Affiliates
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a
                      :href="webUrl + '/about-us'"
                    >
                      <span>About</span>
                    </a>
                  </li>
                  <li>
                    <a
                      :href="webUrl + '/contact-us'"
                    >
                      <span>Contact</span>
                    </a>
                  </li>
                  <li v-if="loggedIn">
                    <a
                      href="#"
                      v-if="loggedIn"
                      class="dropdown-toggle"
                    >
                      <i class="fa fa-user-circle-o"></i>
                      <span class="mr-5 ml-2"> {{user?.first_name}}</span>
                      <i class="fa fa-angle-down"></i>
                      </a>
                    <ul
                      class="dropdown-menu"
                      role="menu"
                    >
                    <!-- <li>
                      <a disabled>
                        <span class="font-purple">
                          {{ `${user?.first_name} ${user?.last_name}` }}
                        </span>
                      </a>
                    </li> -->
                      <li v-if="isSuperAdmin || this.$route.name === 'rent_roll_listings' || this.$route.name === 'rent_roll_listings_show' || this.$route.name === 'confidentiality-agreement-prepare'">
                        <a :href="accountUrl">Account</a>
                      </li>
                      <li>
                        <a class="pointer" @click="handleLogout">Log out</a>
                      </li>
                    </ul>
                  </li>
                  <li v-if="!loggedIn">
                    <a
                        href="/login"
                    >
                      <button class="text-black bg-accent border-radius-8" >Login</button>
                    </a>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                class="navbar-toggle d-lg-none"
                @click="mobileMenuOpen = !mobileMenuOpen"
              >
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              
            </div>
            <!-- Mobile Menu -->
            <div
                v-if="mobileMenuOpen"
                class="mobile-menu"
                style="background: #231e35; z-index: 1050; overflow-y: auto;"
              >
                <!-- Logo and Close Button -->
                <div class="d-flex justify-content-between align-items-center mb-8 logo-mobile-container">
                  <router-link to="/" aria-label="Home">
                    <img
                      src="@/assets/images/header_logo_white.png"
                      alt="The Rent Roll Broker Logo"
                      class="h-30 w-auto object-contain logo-mobile"
                      
                    />
                  </router-link>

                  <button 
                    class="btn btn-link text-white fs-1 p-0"
                    style="text-decoration: none;"
                    @click="mobileMenuOpen = false"
                    aria-label="Close menu"
                  >
                    <i class="fa fa-times close-btn"></i>
                  </button>
                </div>
                <ul class="nav flex-column mt-4 px-3">
                  <li v-for="item in menuItems" :key="item.path" class="nav-item mb-2">
                    <a
                      :href="item.type === 'web' ? (webUrl + item.path) : (adminUrl + item.path)"
                      class="nav-link"
                      @click="mobileMenuOpen = false"
                    >
                      {{ item.name }}
                  </a>
                  </li>
                  <li v-if="!loggedIn" class="nav-item mb-2">
                    <router-link
                      to="/login"
                      class="nav-link"
                      @click="mobileMenuOpen = false"
                    >Login</router-link>
                  </li>
                  <li v-else class="nav-item mb-2">
                    <a
                      href="#"
                      class="nav-link"
                      @click="handleLogout"
                    >Logout</a>
                  </li>
                </ul>
              </div>
          </nav>

        </div>
      </div>
    </header>
  </div>
</template>

<script>
import findIndex from "lodash-es/findIndex";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      adminUrl: process.env.VUE_APP_ADMIN_URL,
      webUrl: process.env.VUE_APP_WEB_URL,
      isMobile: false,
      mobileMenuOpen: false,
      menuItems: [
        { name: 'Listings', path: '/rent-roll-listings' , type:'web'},
        { name: 'Register as Buyer', path: '/buy-a-business' , type:'web'},
        { name: 'Register as Seller', path: '/sell-a-business' , type:'web'},
        { name: 'Articles', path: '/resources/articles' , type:'web'},
        { name: 'Affiliates', path: '/resources/affiliates' , type:'web'},
        { name: 'About', path: '/about-us' , type:'web'},
        { name: 'Contact', path: '/contact-us' , type:'web'},
      ]
    };
  },
  computed: {
    ...mapGetters({
      menus: "app/menus",
      user: "auth/user",
      loggedIn: "auth/loggedIn",
      customer: "auth/customer",
      isSuperAdmin: "auth/isSuperAdmin"
    }),
    isATestingEnv () {
      return !window.location.host.endsWith('.com.au');
    },
    accountUrl() {
      return this.customer === null
        ? `${this.adminUrl}/users/${this.user.id}`
        : `${this.adminUrl}`;
    },
    listingUrl(){
      return `${this.webUrl}/rent-roll-listings`;
    },
    webUrl(){
      return `${this.webUrl}`;
    }
  },
  methods: {
    ...mapActions({
      logout: "auth/logOut",
      clearState: "table/clearState"
    }),
    getActiveRoute(path) {
      if (path.child && path.child.length) {
        return findIndex(path.child, { path: this.$route.path }) >= 0;
      }
      return path.name === "login";
    },
    async handleLogout() {
      await this.logout({ values: { id: this.user.id } });
      await this.clearState();
      await this.$router.push({ name: "login" });
    },
    getLoggedIn(menuItem) {
      return this.loggedIn && menuItem.name === "Login";
    }
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}
.header-logo{
 width: 128px;
 height: 88px;
 margin-top: 16px;
 margin-bottom: 16px;
}

/* Dropdown hover styles */
.navbar-nav li {
  position: relative;
}

.navbar-nav li:hover > .dropdown-menu {
  display: block;
}

/* Arrow rotation on hover */
.navbar-nav li:hover > a .fa-angle-down {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.fa-angle-down {
  transition: transform 0.3s ease;
}

.dropdown-menu {
  display: none;
  position: absolute;
  background: #231e35;
  min-width: 200px;
  padding: 10px 0;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.dropdown-menu li {
  padding: 0;
}

.dropdown-menu li a {
  padding: 8px 20px;
  display: block;
  color: white;
  text-decoration: none;
}

.dropdown-menu li a:hover {
  background: rgba(255,255,255,0.1);
}

@media (min-width: 768px) {
  .container-fluid.page-container{
      padding-left: 96px;
      padding-right: 96px;
  }
  .site-nav-inner .navbar-nav  a{
    font-size: 20px !important;
    color: white;
    font-weight: normal;
    text-transform: none !important;
  }
  .site-nav-inner .navbar-nav .dropdown-menu a{
    font-size: 20px !important;
    color: #211B35;
    font-weight: normal;
    text-transform: none !important;
  }
  .dropdown-menu{
    border-radius: 5px !important;
    border-top:none !important;
  }
  .dropdown-menu li a{
    border-bottom: none !important;
  }
  .nav.navbar-nav li{
    margin-left: 7px;
    margin-right: 7px;
  }
}
@media (max-width: 767.98px) {
  .mobile-menu .nav .nav-item a {
    font-size: 30px !important;
    line-height: 1 !important;
    padding:12px 0 !important;

    
  }
  .container-fluid.page-container{
    padding-left: 32px;
    padding-right: 32px;
  }
  .mobile-menu {
    background: #2c2446f2;
    z-index: 1050;
    overflow-y: auto;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 2.5em;
    opacity: 0.95;
  }
  .logo-mobile-container {
    margin-bottom: 2.5em;
  }
  .close-btn {
    font-size: 3em !important;
  }
}
.navigation-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mr-5 {
  margin-right: 1rem;
}
.mr-5 {
  margin-left: 5px;
}
.border-radius-8{
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 3px;
  padding-bottom: 3px;
  border-radius: 8px;
  font-size: 18px;
  line-height: 28px;
  border: 1px solid #ccd4e9;
}

</style>

